module.exports = __webpack_public_path__ + "img/bit_recharge_icon.a8c0fceb.svg";